import { CardVariations } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

export const LeadCardVariations: CardVariations = {
  content: {
    width: cn("w-full lg:w-1/2 xl:w-full"),
    extraClass: cn("break-words mt-3 lg:pl-3 xl:pl-0"),
    blurb: {
      extraClass: cn(
        "mb-1 max-lg:block font-lucida mt-2 leading-150 -tracking-5 font-medium text-base text-gray-750"
      ),
    },
  },
  kicker: {
    color: "text-blue-175",
    extraClass: cn("font-freightSansPro text-base mb-2"),
  },
  title: {
    size: cn("text-6xl"),
    color: "text-gray-850",
    extraClass: cn("font-lct font-normal -tracking-2 leading-8"),
  },
  image: {
    position: "left",
    width: cn("w-[calc(100%+2.5rem)] md:w-full lg:w-1/2 xl:w-full"),
    aspectRatio: "aspect-3x2",
    imageClassName: cn("object-cover"),
    imageWrapperClass: cn("-mx-5 md:mx-0"),
    orientation: "landscape",
  },
};

export const SubCardVariationsWithImages: CardVariations = {
  content: {
    width: cn("w-[calc(100%-7.5rem)] md:w-full lg:w-1/2 xl:w-full"),
    extraClass: cn(
      "break-words pr-2 md:pr-0 lg:order-2 lg:pl-3 xl:pl-0 xl:pt-3 xl:!flex-grow-0"
    ),
    blurb: {
      extraClass: cn(
        "max-lg:block font-lucida md:mt-2 leading-150 -tracking-5 text-base font-medium text-gray-750"
      ),
    },
  },
  image: {
    position: "right",
    width: cn("w-[7.5rem] lg:w-1/2 xl:w-full"),
    aspectRatio: "aspect-3x2",
    imageClassName: cn("object-cover"),
    extraClass: cn("md:hidden lg:flex lg:order-1"),
    orientation: "landscape",
  },
  title: {
    size: cn("text-xl lg:pb-0"),
    color: "text-gray-850",
    extraClass: cn(
      "font-lct font-semibold -tracking-2 leading-125 mb-2 md:mb-0"
    ),
  },
};

export const SubCardVariationsWithoutImages: CardVariations = {
  image: {
    position: "",
    width: cn("w-full"),
    aspectRatio: "aspect-3x2",
    imageClassName: cn("object-cover"),
    orientation: "landscape",
  },
  title: {
    size: cn("text-lg"),
    color: "text-gray-850",
    extraClass: cn("font-lct font-semibold -tracking-2 leading-125"),
  },
  content: {
    width: "w-full",
    extraClass: cn("break-words"),
  },
};
